<div class="main-div">
  <div class="container pt-m-0">
    <div class="row">
      <div class="col-md-12 dialog-head">
        Profile
      </div>

    </div>

  </div>

  <div class="container">

    <ng-container *ngIf="topErrorMessage && show">
      <div class="row err" *ngFor="let obj of keys1 ">
        <div class="col-12 mb-1 mt-1" *ngFor="let value of obj ">
          <p class="col-12 error" id="err">{{ value }}</p>
        </div>
      </div>
    </ng-container>
    <div class="row" *ngIf="!topErrorMessage">
      <div class="col-12 error">
        {{ errorMsg }}
      </div>
    </div>

    <mat-dialog-content class="dialog-content cust_desc">

      <form #createCustomer="ngForm" class="profile_form" autocomplete="off">
        <div class="form-group row">
          <label for="email" class="col-sm-4 col-12 col-form-label">Email:</label>
          <div class="col-sm-8 col-12" *ngIf="userEmail">
            <input class="form-control" type="email" name="email" id="email" #email="ngModel" [(ngModel)]="userEmail"
                   disabled value="">
          </div>
        </div>
        <div class="form-group row">
          <label for="name" class="col-sm-4 col-12 col-form-label">Name:</label>
          <div class="col-sm-8 col-12" *ngIf="userName">
            <input id="name" type="text" name="name" #name="ngModel" class="form-control" [(ngModel)]="userName"
                   disabled value="">
          </div>
          <!--<div class="col-9">-->
          <!--<input class="form-control" type="text" value="" name="name" id="name">-->
          <!--</div>-->
        </div>
        <div class="form-group row">
          <div class="col-4 d-sm-flex d-none"></div>
          <div class="col-lg-8 col-xl-6 col-md-12 col-7 col-sm-12 mt-m-11">
            <input class="form-control" (click)="showPasswordPanel(createCustomer)" type="button"
                   value="Change password" name="change_password" id="change_password">
          </div>
        </div>
        <ng-container *ngIf="show">
          <div class="form-group row">
            <label for="oldpassword" class="col-4 col-form-label">Current password:</label>
            <div class="col-8">
              <input class="form-control" type="password" value="" name="oldpassword" id="oldpassword"
                     #oldpassword="ngModel" [(ngModel)]="current_password" autocomplete="new-password">
            </div>
          </div>
          <div class="form-group row">
            <label for="newpassword" class="col-4 col-form-label">New password:</label>
            <div class="col-8">
              <input class="form-control" type="password" value="" name="newpassword" id="newpassword"
                     #newpassword="ngModel" [(ngModel)]="new_password" autocomplete="new-password">
            </div>
          </div>
          <div class="form-group row">
            <label for="confirmpassword" class="col-4 col-form-label">Confirm password:</label>
            <div class="col-8">
              <input class="form-control" type="password" value="" name="confirmpassword" id="confirmpassword"
                     #confirmpassword="ngModel" [(ngModel)]="new_password_confirmation" autocomplete="new-password">
            </div>
          </div>

        </ng-container>
        <ng-container>
          <div class="form-group row" [formGroup]="verifyForm">
            <label class="col-sm-12 col-12 col-form-label">2-Step Verification methods</label>

            <div class="col-sm-12 col-12 mt-m-4">
              <label class="mb-2">
                Email
              </label>
              <div class="d-inline-block mx-2" [innerHTML]="this.user_data['email']">
              </div>
            </div>

            <div class="col-sm-12 col-12 mt-m-4">
              <label class="mb-2">
                2FA Application
              </label>
              <div class="d-inline-block mx-2 pl-m-0">
                <button *ngIf="!this.user_data['has_2fa_enabled']"
                        id="verify2FAApp"
                        (click)="verify2FAApp()"
                        class="update-btn">
                  Set up 2FA Application</button>
                <button *ngIf="this.user_data['has_2fa_enabled']"
                        id="disable2FAApp"
                        (click)="disable2FAApp()"
                        class="update-btn">
                  Disable 2FA Application</button>
              </div>
            </div>

          </div>


        </ng-container>
        <div class="row d_footer">

          <div class="col-12 pt-2 mb-4 void_btn">
            <button mat-button [mat-dialog-close]="true" class="update_cancel">Cancel</button>
            <app-loading-button [buttonText]="'Save'" [loadFlag]="loadFlag"
                                [disable]="(createCustomer.invalid || !show)" [buttonWidth]="'39%'"
                                (buttonClick)="save()"></app-loading-button>
            <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->

          </div>
        </div>

      </form>
    </mat-dialog-content>


  </div>
</div>
